import { render, staticRenderFns } from "./quobyte.vue?vue&type=template&id=f28a3bca&"
import script from "./quobyte.vue?vue&type=script&lang=js&"
export * from "./quobyte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports